import { apiClient } from "./client";

export const listStates = () => apiClient.get("/counties/states").then((r) => r.data);
export const listCounties = (params = {}) =>
  apiClient.get("/counties/", { params: { size: 500, ...params } }).then((r) => r.data);
